import { render, staticRenderFns } from "./tree-node.vue?vue&type=template&id=18d4a8d7&scoped=true"
import script from "./tree-node.vue?vue&type=script&lang=js"
export * from "./tree-node.vue?vue&type=script&lang=js"
import style0 from "./tree-node.vue?vue&type=style&index=0&id=18d4a8d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d4a8d7",
  null
  
)

export default component.exports